import React, { useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';

function DownloadFranchiseData() {
  const { ItemList } = useSelector((state) => state.users);
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: 'Franchise Data',
  });

  useEffect(() => {
    handlePrint();
  }, []);

  return (
    <div ref={componentRef} style={{ width: '100%', height: '100%', padding: '20px' }}>
      <div style={{ marginBottom: '20px' }}>
        <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>Franchise Data</h1>
        <Button onClick={handlePrint} variant="primary" style={{ float: 'right' }}>Print</Button>
      </div>
      <table className="table table-striped">
        <thead>
          <tr>
            <th>S.No.</th>
            <th>Registration Date</th>
            <th>Name</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>Gender</th>
            <th>State</th>
            <th>City</th>
            <th>Referral Code</th>
            <th>Franchise Code</th>
            <th>Address</th>
            <th>Status</th>
            <th>Total Appointments</th>
            <th>Total Income</th>
          </tr>
        </thead>
        <tbody>
          {ItemList.map((franchise, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{franchise.registrationDate}</td>
              <td>{franchise.name}</td>
              <td>{franchise.email}</td>
              <td>{franchise.mobile}</td>
              <td>{franchise.gender}</td>
              <td>{franchise.state}</td>
              <td>{franchise.city}</td>
              <td>{franchise.referralCode}</td>
              <td>{franchise.franchiseCode}</td>
              <td>{franchise.address}</td>
              <td>{franchise.status}</td>
              <td>{franchise.appointmentCount}</td>
              <td>{franchise.totalIncome}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default DownloadFranchiseData;
